import { Box, Button } from '@mui/material';
import React from 'react';

const GoogleLogo = () => (
    <svg width="22" height="22" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.3C29.2 35.1 26.7 36 24 36c-5.3 0-9.8-3.4-11.4-8.1l-6.5 5C9.5 39.5 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.1 5.5l6.2 5.3C36.9 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/>
    </svg>
)

export const GoogleButton = (props) => {
    const { onClick, title, type = "button" } = props
    return <Button
        sx={[{
            '&:hover': {
                color: '#333',
                backgroundColor: '#f5f5f5',
            },
        }, {
            width: '90%',
            fontWeight: 'bold',
            borderRadius: 2,
            height: 50,
            backgroundColor: 'white',
            color: '#333',
            border: '1px solid #dddddd',
            maxWidth: 400,
            marginTop: 1.25
        }]}
        disableRipple={true}
        disableFocusRipple={false}
        color={"secondary"}
        type={type}
        onClick={onClick}
    >
        <Box style={{marginTop: 6, marginRight: 10}}>
            <GoogleLogo />
        </Box>
        {title}
    </Button>
}
